import { Trans } from "@lingui/macro";
import { Alert, Button, Container } from "@mantine/core";
import { useNavigate } from "@remix-run/react";
import { Info, X } from "lucide-react";
import { useState } from "react";

interface PortalPinReminderBannerProps {
	onDismiss?: () => void;
}

export function PortalPinReminderBanner({
	onDismiss,
}: PortalPinReminderBannerProps) {
	const navigate = useNavigate();
	const [dismissed, setDismissed] = useState(false);

	if (dismissed) return null;

	const handleDismiss = () => {
		setDismissed(true);
		onDismiss?.();
	};

	const handleSetPin = () => {
		navigate("/portal-profile");
	};

	return (
		<div
			style={{
				background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
				borderBottom: "1px solid #93c5fd",
				padding: "12px 0",
			}}
		>
			<Container size="xl">
				<Alert
					icon={<Info size={20} />}
					color="blue"
					variant="light"
					styles={{
						root: {
							backgroundColor: "transparent",
							border: "1px solid #3b82f6",
							borderRadius: "8px",
						},
						icon: {
							color: "#1e40af",
						},
						message: {
							color: "#1e3a8a",
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							gap: "1rem",
							flexWrap: "wrap",
						},
					}}
					withCloseButton={false}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							gap: "1rem",
							width: "100%",
							flexWrap: "wrap",
						}}
					>
						<div style={{ flex: 1, minWidth: "200px" }}>
							<strong style={{ display: "block", marginBottom: "4px" }}>
								<Trans>Keamanan Akun</Trans>
							</strong>
							<span style={{ fontSize: "14px" }}>
								<Trans>
									Untuk keamanan akun Anda, silakan atur PIN di menu Profil
								</Trans>
							</span>
						</div>
						<div
							style={{
								display: "flex",
								gap: "8px",
								alignItems: "center",
							}}
						>
							<Button
								variant="filled"
								color="blue"
								size="sm"
								onClick={handleSetPin}
								styles={{
									root: {
										background:
											"linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)",
										"&:hover": {
											background:
												"linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)",
										},
									},
								}}
							>
								<Trans>Atur PIN</Trans>
							</Button>
							<Button
								variant="subtle"
								color="gray"
								size="sm"
								onClick={handleDismiss}
								leftSection={<X size={16} />}
							>
								<Trans>Tutup</Trans>
							</Button>
						</div>
					</div>
				</Alert>
			</Container>
		</div>
	);
}
